import API_BASE_URL from "../config/api";
import { refreshToken } from "./tokenRefresh";

const API_URL = `${API_BASE_URL}/v1`;

export const apiFetch = async (endpoint, options = {}) => {
  const token = localStorage.getItem("access_token");
  const headers = {
    "Content-Type": "application/json",
    ...options.headers,
  };

  if (options.body instanceof FormData) {
    delete headers["Content-Type"];
  }

  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  try {
    const response = await fetch(`${API_URL}${endpoint}`, {
      ...options,
      headers,
      credentials: 'include',
    });

    if (response.status === 401) {
      // Try to refresh token silently and retry
      await refreshToken();
      
      const newToken = localStorage.getItem("access_token");
      if (newToken) {
        // Retry with new token
        headers["Authorization"] = `Bearer ${newToken}`;
        const retryResponse = await fetch(`${API_URL}${endpoint}`, {
          ...options,
          headers,
          credentials: 'include',
        });
        
        if (retryResponse.ok) {
          const data = await retryResponse.json().catch(() => ({}));
          return data;
        }
        // If retry failed, throw with status
        const retryData = await retryResponse.json().catch(() => ({}));
        throw { ...retryData, status: retryResponse.status };
      }
      
      // If refresh failed, silently clear and let app handle redirect naturally
      console.log("Token expired, refresh failed");
      localStorage.removeItem("access_token");
      localStorage.removeItem("user");
    }

    const data = await response.json().catch(() => ({}));
    if (!response.ok) {
      // Include status code in the error object
      const error = { ...data, status: response.status };
      throw error;
    }
    return data;
  } catch (err) {
    throw err;
  }
};
